import { useDispatch, useSelector } from 'react-redux'
import ReactModal from 'react-modal'
import { Capacitor } from '@capacitor/core'
import { Button } from 'ui'
import { closeModal, openModal } from 'store/actions/modals'
import { getLocale } from 'services/Dates'
import { getDeviceLocationPermission, getDevicePosition } from 'services/geoUtils'
import PunchService, { punchCardRequiresComment } from 'services/PunchService'

import { t } from 'translations'

const GeolocationRequestModal = ({ event }: { event: MData.Event }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector((state: MStore.RootState) => state.users)
  const { enablePunchComment, requireEmployeeLocation } = useSelector((state: MStore.RootState) => state.settings)
  if (!userInfo) return null
  const locale = userInfo ? getLocale(userInfo.language) : 'en'

  const handleAllow = async () => {
    const geoLocation = await getDevicePosition()
    const permission = await getDeviceLocationPermission()
    if (permission === 'denied' && requireEmployeeLocation) {
      alert(t('employee.punch.ENABLE_LOCATION_SERVICES'))
      return null
    }
    const punchCard = await PunchService.punch(event._id, userInfo, geoLocation)
    dispatch(closeModal())

    // Offer to add comment for the manager if the employee isInLate, isInEarly, isOutEarly or isOutLate
    if (punchCardRequiresComment(punchCard) && enablePunchComment) dispatch(openModal('PunchAddCommentModal', { punchCard, locale }))
  }

  const handleDeny = () => {
    dispatch(closeModal())
    dispatch(openModal('GeolocationConfirmationModal', { event }))
  }

  return (
    <ReactModal
      isOpen
      className="merinio-modal"
      overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
      shouldFocusAfterRender
    >
      <div className="text-center" style={{ fontWeight: 600, fontSize: '1.8rem' }}>
        {t('employee.punch.ALLOW_ACCESS.TITLE')}
      </div>
      <div className="my-4" style={{ fontSize: '1.5rem' }}>
        {t('employee.punch.ALLOW_ACCESS.SUMMARY')}
      </div>
      <div className="my-4">
        <div className="my-4 d-flex justify-content-start">
          <div className="mr-2">
            <i className="fa-solid fa-sharp fa-location-crosshairs" />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: '1.2rem' }}>{t('employee.punch.ALLOW_ACCESS.USE_TITLE')}</div>
            <div>{t('employee.punch.ALLOW_ACCESS.USE_CONTENT')}</div>
          </div>
        </div>
        <div className="my-4 d-flex justify-content-start">
          <div className="mr-2">
            <i className="fa-solid fa-gear" />
          </div>
          <div>
            <div style={{ fontWeight: 600, fontSize: '1.2rem' }}>{t('employee.punch.ALLOW_ACCESS.CONTROL_TITLE')}</div>
            <div>{t('employee.punch.ALLOW_ACCESS.CONTROL_CONTENT')}</div>
          </div>
        </div>
      </div>
      <div>
        <Button color="success" className="btn-lg btn-block btn-outline-danger" onClick={handleAllow}>
          {t('employee.punch.ALLOW_ACCESS.ALLOW')}
        </Button>
      </div>
      <div>
        <Button className="text-success btn-lg btn-block" onClick={handleDeny}>
          {t('employee.punch.ALLOW_ACCESS.DONT_ALLOW')}
        </Button>
      </div>
    </ReactModal>
  )
}

export default GeolocationRequestModal
